import Model, { attr } from '@ember-data/model';

export default class GradeLevelModel extends Model {
  @attr('string')
  name;

  @attr('number')
  rank;
}
